(function ($, exports) {
	exports.init = function () {
		var $anchors = $('.c-hero').find('a[href^="#"]');
		var $doc = $('body, html');

		$anchors.on('click', function (e) {
			e.preventDefault();
			var hash = $(this).attr('href');

			if (hash.length > 1) {
				var top = $(hash).offset().top - 50;

				$doc.animate({ scrollTop: top }, 1000);
			}
		});
	};
})(jQuery, (this.ANCHORS = {}));
